import { Component,ViewChild  } from '@angular/core';
import { IonicPage, NavParams } from 'ionic-angular';
import { NavController, ModalController, AlertController } from 'ionic-angular';
import * as moment from 'moment';

import { VariablesProvider } from '../../providers/variables/variables';
import { FuncionesProvider } from '../../providers/funciones/funciones';
import { PicajesPage } from '../../pages/picajes/picajes';
import { HomePage } from '../../pages/home/home';

import { CalendarioPage } from '../../pages/calendario/calendario';
import { LoginPage } from '../../pages/login/login';
import { CalendarModal, CalendarModalOptions, DayConfig, CalendarResult } from "ion2-calendar";
import { CalendarComponentOptions } from 'ion2-calendar'
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import * as XLSX from '../../xlsx';
import { NgZone  } from '@angular/core';
import { Events } from 'ionic-angular';
import { ReservaslinPage } from '../../pages/reservaslin/reservaslin';

import { File } from '@ionic-native/file';


@Component({
  selector: 'page-salas',
  templateUrl: 'salas.html',
})
export class SalasPage {
  @ViewChild('valo43') th43 ;
  diasdefiesta;
  myForm: FormGroup;
  myForm1: FormGroup;
  myForm2: FormGroup;
  misapp: Array<{title: string, descripcion: string, imagen: string , component: any}>;
  formulario = {objeto1: "", inicio1:"",fin1:"",motivo1:"",trabajador1:""};
  resultado;
  date: string = "";
  type: 'string'; // 'string' | 'js-date' | 'moment' | 'time' | 'object'
  minuto = []; //= {valor: "1",color: "1"}
  color = []; //= {valor: "1",color: "1"}
  //cabecera = []; //= {valor: "1",color: "1"}
  trabajadores;
  objetos;
  obras;
  puestos;
  turnos;
  valo="654321123456" ;
  formulario2 = {valor: ""}
  trabajadoresKeys;
  values:Array<string> = [];
  rs_xls;
  muestragif;
  reserva:any;
  todosLosSalas;
  nombreSalas;
  salaElegido = "";
  diasOcupados;
  primeravez = "si";
  ID;
  solodia;
  isEnabled:boolean=false;
  horainicial;
  horafinal;
  reservas;
  anosa;
  messa;
  diasa;


  horas: Array<string> = ["00", "01", "02","03", "04", "05","06", "07", "08","09", "10", "11","12", "13", "14","15", "16", "17","18", "19", "20","21", "22", "23","24"];
  dias: Array<string> = ["Lun", "Mar", "Mie","Jue", "Vie", "Sab","Dom"];

  //Arrays de datos:
  meses: Array<string> = ["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"];
  lasemana: Array<string> = ["Domingo","Lunes","Martes","Miércoles","Jueves","Viernes","Sábado"]
  diassemana: Array<string> = ["lun","mar","mié","jue","vie","sáb","dom"];
 
  pos11;  pos12;  pos13;  pos14;  pos15;  pos16;  pos17;  
  pos21;  pos22;  pos23;  pos24;  pos25;  pos26;  pos27;  
  pos31;  pos32;  pos33;  pos34;  pos35;  pos36;  pos37;
  pos41;  pos42;  pos43;  pos44;  pos45;  pos46;  pos47;
  pos51;  pos52;  pos53;  pos54;  pos55;  pos56;  pos57;
  pos61;  pos62;  pos63;  pos64;  pos65;  pos66;  pos67;
  pos71;  pos72;  pos73;  pos74;  pos75;  pos76;  pos77;

  hoy;
  diasemhoy; //dia semana actual
  diahoy; //dia mes actual
  meshoy; //mes actual
  annohoy; //año actual
  // Elementos del DOM: en cabecera de calendario 
  tit; //cabecera del calendario
  ant; //mes anterior
  pos; //mes posterior
  // Elementos del DOM en primera fila
  f0;
  //Pie de calendario
  pie;

  //formulario: datos iniciales:
  mesant;
  mespos;

  // Definir elementos iniciales:
  mescal; //mes principal
  annocal; //año principal
  primeromes;
  ultimomes;
  verfila;
  verfilaactual;
  losdiasdelmes;
  lashorasdeldia;
  lostrabajadoresdelmes;
  elemento;
  elemento2;
  colo;
  color11;  color12;  color13;  color14;  color15;  color16;  color17;
  color21;  color22;  color23;  color24;  color25;  color26;  color27;
  color31;  color32;  color33;  color34;  color35;  color36;  color37;
  color41;  color42;  color43;  color44;  color45;  color46;  color47;
  color51;  color52;  color53;  color54;  color55;  color56;  color57;
  color61;  color62;  color63;  color64;  color65;  color66;  color67;
  color71;  color72;  color73;  color74;  color75;  color76;  color77;

  constructor(
  	public navParams: NavParams,
    public fb: FormBuilder,
    private alertCtrl: AlertController,
    public modalCtrl: ModalController,
  	public navCtrl: NavController,
    public funciones:FuncionesProvider,
  	public variables:VariablesProvider,
    public file: File,
    public events: Events,
    private zone: NgZone
    ) { 

    
    this.primeromes=new Date(this.variables.AnnoCal,this.mescal,1); //buscar primer día del mes
    this.verfilaactual=1;

    this.hoy=new Date(); //objeto fecha actual
    //console.log("HOY:" + this.hoy);
    this.diasemhoy=this.hoy.getDay(); //dia semana actual
    //console.log("DIASEMHOY:" + this.diasemhoy);
    this.diahoy=this.hoy.getDate(); //dia mes actual
    
    this.meshoy=this.hoy.getMonth(); //mes actual
    this.annohoy=this.hoy.getFullYear(); //año actual
    
    if (this.variables.DIASALA){
    }else{
      this.variables.DIASALA = this.annohoy + "-" + ("0" + (this.meshoy+1)).slice(-2) + "-" + ("0" + this.diahoy).slice(-2);
    }

     //console.log("Dias salas:" + this.variables.DIASALA);

    if (this.variables.MesCal){

    }else{
    // Definir elementos iniciales:
      this.variables.MesCal = this.meshoy; //mes principal
      this.variables.AnnoCal = this.annohoy //año principal
    }
    //iniciar calendario:
    this.cabecera(); 
    //this.primeralinea()
    this.escribirdias();
    this.verfilaactual=this.verfila;
    this.isEnabled=true;

     
     this.primeromes=new Date(this.variables.AnnoCal,this.variables.MesCal,1); //buscar primer día del mes

     var prsem=this.primeromes.getDay(); //buscar día de la semana del día 1
     prsem--; //adaptar al calendario español (empezar por lunes)
     //console.log("Primer dia semana"  + prsem);
     if (prsem==-1) {prsem=6;}       

     //buscar fecha para primera celda:
     var diaprmes=this.primeromes.getDate();

     var prcelda=diaprmes-prsem; //restar días que sobran de la semana

    this.colo = [];
    var i;
    for (i=1;i<50;i++) {
        this.colo.push("#C48787")
    }

    this.anosa=this.variables.DIASALA.substring(0,this.variables.DIASALA.indexOf("-"));
    if (this.anosa.length==2){ this.anosa = "20" + this.anosa;}

    this.messa=this.variables.DIASALA.substring(this.variables.DIASALA.indexOf("-")+1 ,this.variables.DIASALA.lastIndexOf("-"));
    if (this.messa.length==1){ this.messa = "0" + this.messa;}

    this.diasa=this.variables.DIASALA.substring(this.variables.DIASALA.lastIndexOf("-")+1);
    if (this.diasa.length==1){this.diasa = "0" + this.diasa;}

     //console.log("Compara" + this.messa + "=" + ("0" + (this.variables.MesCal+1)).slice(-2));


     if (this.messa==("0" + (this.variables.MesCal+1)).slice(-2) && this.variables.AnnoCal==this.anosa) { 
           //console.log(this.diahoy);
           this.colo[Number(this.diasa)+prsem] = "#3F9933";
      }






    if (this.variables.AnnoCal==this.annohoy && this.variables.MesCal==this.meshoy){
       this.colo[this.diahoy+prsem] = "#D52121";
    }

    //******************
    //    aceeso user normal
    if (this.variables.CONTROLACCESO != 11){

     // this.obtenerSalasconreserva(this.valo,this.variables.MesCal,this.variables.AnnoCal);
    
    }else{
      //console.log('ACCESO DE SOLO LECTURA DE SUS USUARIO' + this.variables.emailactivo);
    //  this.obtenerSalasconreserva(this.variables.emailactivo,this.variables.MesCal,this.variables.AnnoCal);

    }
    this.horainicial = "00:00";
    this.horafinal = "24:00";


  // console.log("Priema vez es:" + this.variables.primeravez);

    if (this.variables.primeravez=="si"){
      //console.log("ENTRA EN PRIMERA VEZ ---------------------------");
      //this.variables.TIPO = "sala";
      //this.variables.OpcionAReservar  ="salaS";              
      this.variables.TIPO = "sala";
      this.variables.OpcionAReservar  ="SALAS";              
      //this.obtieneDias();
   	  this.variables.salaElegido = "Elija un objeto a reservar";
	    this.variables.primeravez="no";
    }

   this.myForm = this.fb.group({
      objeto: ['', [Validators.maxLength(0)]],
      inicio: ['' ],
      fin: ['' ],
      trabajador: ['' ],
      motivo: ['']
     });

 	this.myForm1 = this.fb.group({
      objeto1: [''],
      inicio1: ['' ],
      fin1: ['' ],
      trabajador1: ['' ],
      motivo1: ['']    
     });

      this.variables.btatras = true;
      var sum = 0;
      var horas=0;
      
      this.muestragif = "si";

  
  	}


    //cabecera del calendario
 cabecera() {

         this.tit=this.meses[this.variables.MesCal]+" de "+this.variables.AnnoCal;
         this.mesant=this.variables.MesCal-1; //mes anterior
         this.mespos=this.variables.MesCal+1; //mes posterior
         if (this.mesant<0) {this.mesant=11;}
         if (this.mespos>11) {this.mespos=0;}
         this.ant=this.meses[this.mesant];
         this.pos=this.meses[this.mespos];
         //console.log("MES:" + this.variables.AnnoCal + "/" + this.variables.MesCal);
          this.escribirdias();
         } 
 mesantes() {
         this.primeromes=new Date(this.variables.AnnoCal,this.variables.MesCal,1) //buscar primer día del mes
         var nuevomes=new Date() //nuevo objeto de fecha
         this.primeromes--; //Restamos un día al 1 del mes visualizado
         nuevomes.setTime(this.primeromes) //cambiamos fecha al mes anterior 
         this.variables.MesCal=nuevomes.getMonth() //cambiamos las variables que usarán las funciones
         this.variables.AnnoCal=nuevomes.getFullYear()
         this.cabecera(); //llamada a funcion de cambio de cabecera
         this.escribirdias();
         }
//ver mes posterior
mesdespues() {
         this.primeromes=new Date(this.variables.AnnoCal,this.variables.MesCal,1) //buscar primer día del mes
         var nuevomes=new Date() //nuevo obejto fecha
         var tiempounix= this.primeromes.getTime() //tiempo de primero mes visible
         tiempounix=tiempounix+(45*24*60*60*1000) //le añadimos 45 días 
         nuevomes.setTime(tiempounix) //fecha con mes posterior.
         this.variables.MesCal=nuevomes.getMonth() //cambiamos variables 
         this.variables.AnnoCal=nuevomes.getFullYear()
         this.cabecera() //escribir la cabecera 
         this.escribirdias();
         }

 semanaantes() {
       this.verfilaactual--;
       if (this.verfilaactual<=0) {
           this.mesantes(); 
           this.verfilaactual=this.verfila;
       }

   }
//ver mes posterior
semanadespues() {
      this.verfilaactual++;
       if (this.verfilaactual>this.verfila) {
           this.mesdespues(); 
          this.verfilaactual=1;
       }

        
//         this.cabecera() //escribir la cabecera 
//         this.escribirdias();
         }         
//rellenar celdas con los días
escribirdias() {
         //Buscar dia de la semana del dia 1 del mes:

         var fila;
         var i;
         var j;
         var midia;
         var mimes;
         var mianno;
         var celda;

          
   
          this.colo = [];
          var i;
          for (i=1;i<50;i++) {
            this.colo.push("#C48787")
          }

         this.primeromes=new Date(this.variables.AnnoCal,this.variables.MesCal,1); //buscar primer día del mes

         var prsem=this.primeromes.getDay(); //buscar día de la semana del día 1
         prsem--; //adaptar al calendario español (empezar por lunes)

         if (prsem==-1) {prsem=6;}       
  
         //buscar fecha para primera celda:
         var diaprmes=this.primeromes.getDate();

         var prcelda=diaprmes-prsem; //restar días que sobran de la semana

         var dias=new Date(this.variables.MesCal, this.variables.MesCal+1,0).getDate();
         this.ultimomes=new Date(this.variables.MesCal, this.variables.MesCal+1,0).getDate();

         this.losdiasdelmes = [];

         for (i=1;i<this.ultimomes+1;i++) {
           this.losdiasdelmes.push(("0" + i).substr(-2));
         }

         this.lashorasdeldia = [];

         for (i=1;i<24;i++) {
           this.lashorasdeldia.push(("0" + i).substr(-2));
         }

         //console.log(this.lashorasdeldia);

         var dias= dias + parseInt(prsem);
         
         this.verfila = Math.ceil(dias / 7);

         var empezar=this.primeromes.setDate(prcelda); //empezar= tiempo UNIX 1ª celda
         var diames=new Date(); //convertir en fecha
         diames.setTime(empezar); //diames=fecha primera celda.


         



         //Recorrer las celdas para escribir el día:
         for (i=1;i<7;i++) { //localizar fila
                 for (j=1;j<8;j++) {
                 midia=diames.getDate() 
                 mimes=diames.getMonth()
                 mianno=diames.getFullYear()


                 switch (i) {
                   case 1:
                         switch (j) {
                           case 1:
                             this.pos11=midia ;
                             break;
                           case 2:
                             this.pos12=midia;
                             break;
                           case 3:
                             this.pos13=midia ;
                             break;
                           case 4:
                             this.pos14=midia ;
                             break;
                           case 5:
                             this.pos15=midia ;
                             break;
                           case 6:
                             this.pos16=midia ;
                             break;
                           case 7:
                             this.pos17=midia ;
                             break;
                         }
                     break;
                    case 2:
                         switch (j) {
                           case 1:
                             this.pos21=midia ;
                             //Recuperar estado inicial al cambiar de mes:
                             //celda.style.backgroundColor="#9bf5ff";
                             //celda.style.color="#492736";
                             break;
                           case 2:
                             this.pos22=midia;
                             break;
                           case 3:
                             this.pos23=midia ;
                             break;
                           case 4:
                             this.pos24=midia ;
                             break;
                           case 5:
                             this.pos25=midia ;
                             break;
                           case 6:
                             this.pos26=midia ;
                             break;
                           case 7:
                             this.pos27=midia ;
                             break;
                         }
                     break;                
                    case 3:
                         switch (j) {
                           case 1:
                             this.pos31=midia ;
                             //Recuperar estado inicial al cambiar de mes:
                             //celda.style.backgroundColor="#9bf5ff";
                             //celda.style.color="#492736";
                             break;
                           case 2:
                             this.pos32=midia;
                             break;
                           case 3:
                             this.pos33=midia ;
                             break;
                           case 4:
                             this.pos34=midia ;
                             break;
                           case 5:
                             this.pos35=midia ;
                             break;
                           case 6:
                             this.pos36=midia ;
                             break;
                           case 7:
                             this.pos37=midia ;
                             break;
                         }
                     break;
                   case 4:
                         switch (j) {
                           case 1:
                             this.pos41=midia ;
                             //Recuperar estado inicial al cambiar de mes:
                             //celda.style.backgroundColor="#9bf5ff";
                             //celda.style.color="#492736";
                             break;
                           case 2:
                             this.pos42=midia;
                             break;
                           case 3:
                             this.pos43=midia ;
                             break;
                           case 4:
                             this.pos44=midia ;
                             break;
                           case 5:
                             this.pos45=midia ;
                             break;
                           case 6:
                             this.pos46=midia ;
                             break;
                           case 7:
                             this.pos47=midia ;
                             break;
                         }
                     break;

                   case 5:
                         switch (j) {
                           case 1:
                             this.pos51=midia ;
                             //Recuperar estado inicial al cambiar de mes:
                             //celda.style.backgroundColor="#9bf5ff";
                             //celda.style.color="#492736";
                             break;
                           case 2:
                             this.pos52=midia;
                             break;
                           case 3:
                             this.pos53=midia ;
                             break;
                           case 4:
                             this.pos54=midia ;
                             break;
                           case 5:
                             this.pos55=midia ;
                             break;
                           case 6:
                             this.pos56=midia ;
                             break;
                           case 7:
                             this.pos57=midia ;
                             break;
                         }
                     break;

                   case 6:
                         switch (j) {
                           case 1:
                             this.pos61=midia ;
                             //Recuperar estado inicial al cambiar de mes:
                             //celda.style.backgroundColor="#9bf5ff";
                             //celda.style.color="#492736";
                             break;
                           case 2:
                             this.pos62=midia;
                             break;
                           case 3:
                             this.pos63=midia ;
                             break;
                           case 4:
                             this.pos64=midia ;
                             break;
                           case 5:
                             this.pos65=midia ;
                             break;
                           case 6:
                             this.pos66=midia ;
                             break;
                           case 7:
                             this.pos67=midia ;
                             break;
                         }
                     break;
                  case 7:
                         switch (j) {
                           case 1:
                             this.pos71=midia ;
                             //Recuperar estado inicial al cambiar de mes:
                             //celda.style.backgroundColor="#9bf5ff";
                             //celda.style.color="#492736";
                             break;
                           case 2:
                             this.pos72=midia;
                             break;
                           case 3:
                             this.pos73=midia ;
                             break;
                           case 4:
                             this.pos74=midia ;
                             break;
                           case 5:
                             this.pos75=midia ;
                             break;
                           case 6:
                             this.pos76=midia ;
                             break;
                           case 7:
                             this.pos77=midia ;
                             break;
                         }
                     break;                     

                   }
                 //domingos en rojo


 
                 if (j==6) { 
                    //celda.style.color="#f11445";
                    }
                 //dias restantes del mes en gris
                 if (mimes!=this.variables.MesCal) { 
                    //celda.style.color="#a0babc";
                    }

                  this.anosa=this.variables.DIASALA.substring(0,this.variables.DIASALA.indexOf("-"));
                  if (this.anosa.length==2){ this.anosa = "20" + this.anosa;}

                  this.messa=this.variables.DIASALA.substring(this.variables.DIASALA.indexOf("-")+1 ,this.variables.DIASALA.lastIndexOf("-"));
                  if (this.messa.length==1){ this.messa = "0" + this.messa;}

                  this.diasa=this.variables.DIASALA.substring(this.variables.DIASALA.lastIndexOf("-")+1);
                  if (this.diasa.length==1){this.diasa = "0" + this.diasa;}

                   if (this.messa==("0" + (this.variables.MesCal+1)).slice(-2) && this.variables.AnnoCal==this.anosa ) { 
                         //console.log(this.diahoy);
                         this.colo[Number(this.diasa)+prsem] = "#3F9933";
                    }
                 if (this.meshoy==this.variables.MesCal && midia==this.diahoy && this.variables.AnnoCal==this.annohoy ) { 
                         this.colo[this.diahoy+prsem] = "#D52121";
                    }
                 //pasar al siguiente día
                 midia=midia+1;
                 diames.setDate(midia);
                 }

                //******************

                
                  //    aceeso user normal
                  if (this.variables.CONTROLACCESO != 11){
                    this.obtenerSalasconreserva(this.valo,this.diasa,this.messa,this.anosa);
                  
                  }else{
                    this.obtenerSalasconreserva(this.variables.emailactivo,this.diasa,this.messa,this.anosa);

                  }
             }
         }


	obtenerSalasconreserva(trabajador,dia,mes,ano){


  	//	this.todosLosSalas = [];
      
  	//	this.funciones.obtenerSalasconreserva(trabajador,dia,mes+1,ano).then(
		//	data => {
		//		this.todosLosSalas = data;
		//	}
  	//	)	
	}

zeroFill( number, width )
{
  width -= number.toString().length;
  if ( width > 0 )
  {
    return new Array( width + (/\./.test( number ) ? 2 : 1) ).join( '0' ) + number;
  }
  return number + ""; // siempre devuelve tipo cadena
}
  
 


	eliminaReserva(value){
      let alert = this.alertCtrl.create({
          title: 'Borrar.',
          message: '¿Confirma que desea liberar la reserva?',
          cssClass: 'alertCustomCss',
          buttons: [{
              text: 'No',
              role: 'No',
              handler: () => {  }
            },{
              text: 'Si',
              handler: () => {

                this.ID = value;
                this.funciones.eliminaReserva(this.ID)
               // this.obtieneDias();
                this.navCtrl.setRoot(this.navCtrl.getActive().component);

              }
            }
          ]
        });
        alert.present();
	}

	obtieneDias2(){
       this.variables.diasOcupados = [];
       this.variables._daysConfig = [];
      var f = new Date();
      this.date =  f.getFullYear() + "-" + ("0" + (f.getMonth() + 1)).slice(-2) + "-" +("0" + (f.getDate())).slice(-2) ;
      this.funciones.obtenerReservas(this.variables.valorUsuario, this.date).then(
          data => {
              this.variables.diasOcupados = data;

            for (var _i = 0; _i < this.variables.diasOcupados.length; _i++) {

                    this.variables._daysConfig.push({
                    date: new Date(this.variables.diasOcupados[_i].FECHA),
                    subTitle: "",
                    //marked:true
                    cssClass: 'diaOcupado'
                })
            }
             // this.solodia = this.variables.diasOcupados[this.variables.valorUsuario].FECHA.slice(9);  
              this.navCtrl.setRoot(this.navCtrl.getActive().component);
            }
        )
	}

editarreserva(id,dia,trabajador,obra,supervisado){

var texto;
var reservacompleta =  {};
var ano;
var mes;
var dia;

reservacompleta["id"] = this.reservas[id].ID;
texto = this.reservas[id].DIAS;

ano=texto.substring(0,texto.indexOf("-"));
if (ano.length==2){ ano = "20" + ano;}

mes=texto.substring(texto.indexOf("-")+1 ,texto.lastIndexOf("-"));
if (mes.length==1){ mes = "0" + mes;}

dia=texto.substring(texto.lastIndexOf("-")+1);
if (dia.length==1){dia = "0" + dia;}
    
this.reservas[id].DIAS = ano + "-" + mes + "-" + dia;

reservacompleta["dia"] = this.reservas[id].DIAS;
reservacompleta["trabajador"] = this.reservas[id].TRABAJADOR;
reservacompleta["obra"] = this.reservas[id].OBRA;
reservacompleta["supervisado"] = this.reservas[id].SUPERVISADO;

  
  this.funciones.editarreservasalas(reservacompleta).then(
        data => {
  
          if (data[0].RESULTADO=="OK"){

            let alert = this.alertCtrl.create({
              title: 'Reservar.',
              message: 'Los datos se han actualizado con éxito.',
              cssClass: 'alertCustomCss',
              buttons: [{
                  text: 'Ok',
                  role: 'Ok',
                  handler: () => {

                      this.navCtrl.setRoot(this.navCtrl.getActive().component);

                    }
                }              ]
            });
            alert.present();

          }else{

            let alert = this.alertCtrl.create({
                title: 'Resultado',
                message: 'Error:' + JSON.stringify(data),
                cssClass: 'alertCustomCss'
             
              });
              alert.present();
         }

        },
        err=>{
          //console.log(err);
         }

        )


  } // fin picando


 valChange(campo:string, value:string, index:number):void{
      
      //alert("Campo->" + campo + "valor->" + value + "lugar->" + index)

      switch (campo) {

         case "DIA":
           var texto = value;
           var texto2 = "";
           var ano;
           var mes;
           var dia;

           this.reservas[index].DIAS = value;
           break;
            
         case "SUPERVISADO":
           this.reservas[index].SUPERVISADO = value;
           break;

         default:
           // code...
           break;
       }
    }

ponencampoinicial(campo:string, value:string):void{

        switch (campo) {
          case "OPCION":
            if (value=="salas") { 
              this.variables.OpcionAReservar  ="SALAS";
              this.variables.TIPO = "sala";
      
              
            } else {
              this.variables.OpcionAReservar  ="VEHICULOS";              
              this.variables.TIPO = "sala";
            }

            this.navCtrl.setRoot(this.navCtrl.getActive().component);
           
          default:
             // code...
          break;
         }

 }

ponencampo(campo:string, value:string):void{

    if (this.variables.valorUsuario != value){
		//this.navCtrl.push(ReservarPage);
	      switch (campo) {
         

	        case "OBJETO":
	           this.formulario.objeto1 = value;

	           	for (var _i = 0; _i < this.todosLosSalas.length; _i++) {
	           		//console.log("EL VALOR DE VALUE"+this.todosLosSalas[_i].NOMBRE);
	           		//console.log("EL LENGTH "+this.todosLosSalas.length);
      				 	if (value == this.todosLosSalas[_i].ID){
      				 		this.variables.salaElegido = this.todosLosSalas[_i].NOMBRE;
      				 		//console.log("EL VALOR DE VALUE"+this.todosLosSalas[_i].ID);
      				 	break;
      				 	}
      				 	
      				 }
  				 

  	        break;
	         
	        default:
	           // code...
	        break;
	       }
	      //console.log("EL ID ELEGIDO ES " + this.formulario.objeto1);
	      this.variables.valorUsuario = this.formulario.objeto1;
       // this.variables.primeravez = "si";
	      //this.obtieneDias();
    }
 }
   
salir(){
   this.navCtrl.push(HomePage);
}



onChange($event) {

    this.variables.DIA  = $event;
    //this.storage.set('DIASELECIONADO', this.variables.DIA );
    //this.obtenertrabajadores("formulario");
    //this.formulario.dia1 = cadena.substr(8, 2);
    //this.formulario.mes1 = cadena.substr(5, 2);
  }



seldate(dia){


  this.variables.DIASALA = (this.variables.AnnoCal) + "-" + ("0" + (this.variables.MesCal + 1 )).slice(-2) + "-" + ("0" + (dia)).slice(-2);

  //console.log("DIASALA:" + this.variables.DIASALA)
        
  this.navCtrl.setRoot(this.navCtrl.getActive().component);   


}


selsala(id,numero){


        
     //console.log("VEH:" + this.variables.AnnoCal + "/" + this.variables.MesCal);

            let myModal = this.modalCtrl.create(ReservaslinPage, {
              'trabajador':this.variables.emailactivo,
              'codigo': numero,
              'colo':this.colo,
              'diahoy':this.diahoy ,
              'mes':this.variables.MesCal,
              'ano':this.variables.AnnoCal,
              'id':id,
              'rsx': this.todosLosSalas,
              'losdiasdelmes':this.losdiasdelmes,
              'tabla': "salas_insertar",
              'caption': 'Seleccione los datos'
            }
            );

            myModal.onDidDismiss((data: any) => { 
                       
                this.navCtrl.setRoot(this.navCtrl.getActive().component);   
        
            }); 
            myModal.present();
  }


 edisala(id,number){

     

        
     //console.log("VEH:" + this.variables.AnnoCal + "/" + this.variables.MesCal);

      var valor= String(number);
      var valor= this.zeroFill(valor,2)
      this.reservas = [];
      this.funciones.obtenerreservas(id,this.variables.zfill(this.variables.AnnoCal,2) + "-" + this.variables.zfill(this.variables.MesCal+1,2) + "-" + valor ).then(
      data => {
        this.reservas = data;
         let myModal = this.modalCtrl.create(ReservaslinPage, {
              'trabajador':this.reservas[0].TRABAJADOR,
              'codigo': this.reservas[0].ID,
              'colo':this.colo,
              'diahoy':this.diahoy ,
              'mes':this.variables.MesCal,
              'ano':this.variables.AnnoCal,
              'id':this.reservas[0].ID,
              'rsx': this.reservas,
              'losdiasdelmes':this.losdiasdelmes,
              'tabla': "salas_editar",
              'caption': 'Editar',
              'dias': this.reservas[0].DIAS,
              'inicio': this.reservas[0].INICIO,
              'fin': this.reservas[0].FIN,
              'obra': this.reservas[0].OBRA
            }
            );
            myModal.onDidDismiss((data: any) => { 
              this.navCtrl.setRoot(this.navCtrl.getActive().component);   
            }); 
            myModal.present();

      }
      )  
  }


}



// WEBPACK FOOTER //
// ./src/pages/salas/salas.ts